import { all } from "redux-saga/effects";
import { loginSaga } from "../login/loginSaga";
import { tenantSaga } from "../tenants/tenantSaga";
export default function* RootSaga() {
    yield all([
        loginSaga(),
        tenantSaga()
    ])
}